import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { message } from "antd";
import HomeSeoService from "services/HomeSeoService";

export const initialState = {
  updateLoading: false,
  loadingGetDetails: false,
};

export const Get = createAsyncThunk(
  "/HomeSEO/Get",
  async (_, { rejectWithValue }) => {
    try {
      const response = await HomeSeoService.Get();
      if (response.success === false) {
        return rejectWithValue(response.message);
      } else {
        return response.result;
      }
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Something Went Wrong !"
      );
    }
  }
);

export const Update = createAsyncThunk(
  "/HomeSEO/Update",
  async (data, { rejectWithValue }) => {
    try {
      const response = await HomeSeoService.Update(data);
      if (response.success === false) {
        message.error({
          content: ` ${response.message}`,
        });
        return rejectWithValue(response.message);
      } else {
        message.success({
          content: `Success !`,
        });

        return response.result;
      }
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Something Went Wrong !"
      );
    }
  }
);

export const homeSeoSlice = createSlice({
  name: "homeSeoSlice",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(Get.pending, (state) => {
        state.loadingGetDetails = true;
      })
      .addCase(Get.fulfilled, (state, action) => {
        state.loadingGetDetails = false;
      })
      .addCase(Get.rejected, (state, action) => {
        state.loadingGetDetails = false;
      })
      .addCase(Update.pending, (state) => {
        state.updateLoading = true;
      })
      .addCase(Update.fulfilled, (state, action) => {
        state.updateLoading = false;
      })
      .addCase(Update.rejected, (state, action) => {
        state.updateLoading = false;
      });
  },
});

export const {} = homeSeoSlice.actions;

export default homeSeoSlice.reducer;
